import CroppedSheet, { MapboxSheetLayerConfig } from 'components/CroppedSheet';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { FC, useContext } from 'react';

const SheetAlignerLayers: FC = () => {
  const { state: appState } = useContext(AppStoreContext);

  const sheetEntries = appState.getVisibleSheetEntries().valueSeq();
  const layerPaint = {
    'raster-opacity': 0.7,
  };

  return (
    <>
      {sheetEntries.map(({ mappedSheetVersion, sheetVersion }) => {
        if (!mappedSheetVersion.imagesource) {
          return null;
        }
        const { corners, croppath } =
          mappedSheetVersion.imagesource.calibrationconfig;
        const cornersArr = [
          [corners.topleft.longitude, corners.topleft.latitude],
          [corners.topright.longitude, corners.topright.latitude],
          [corners.bottomright.longitude, corners.bottomright.latitude],
          [corners.bottomleft.longitude, corners.bottomleft.latitude],
        ];
        const sheetSource = {
          id: `sheet-aligner-sheet-source-${mappedSheetVersion.pageid}`,
          type: 'image',
          url: mappedSheetVersion.imagesource.url,
          coordinates: cornersArr,
        };
        const sheetLayer: MapboxSheetLayerConfig = {
          id: `sheet-aligner-sheet-layer-${mappedSheetVersion.pageid}`,
          type: 'raster',
          source: sheetSource.id,
          paint: layerPaint,
        };

        return (
          <CroppedSheet
            key={`cropped-sheet-${mappedSheetVersion.pageid}`}
            cropPath={croppath}
            sheetLayer={sheetLayer}
            sheetSource={sheetSource}
            sheetVersion={sheetVersion}
          />
        );
      })}
    </>
  );
};

export default SheetAlignerLayers;
